// @givmo/app-charity — a viewport-width hook for the one layout CSS alone cannot express: putting a
// control in a DIFFERENT container on the phone than on the desk (reparenting is not a media query).
//
// Tailwind's breakpoints are the source of truth for the queries; `sm` is 40rem. The desktop
// composition is the default: without `matchMedia` (jsdom, a server render) the hook answers `true`,
// so a phone-only structure is opt-in by measurement and every existing desktop pin holds unchanged.

import { useSyncExternalStore } from 'react';

/** Tailwind's `sm` breakpoint as a media query. */
export const SM_MEDIA_QUERY = '(min-width: 40rem)';

function supported(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

/** True when the viewport is at least `query` wide; true wherever `matchMedia` is unavailable. */
export function useMinWidth(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (!supported()) return () => {};
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => (supported() ? window.matchMedia(query).matches : true),
    () => true,
  );
}
